/* eslint-disable no-useless-escape */
/*
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 
 */
/**
 * 格式化日期
 * @prama t 时间戳
 * @return str MM-dd HH:mm
 */
export function formatDate(t) {
    t = t || Date.now();
    let time = new Date(t);
    let str = time.getMonth() < 9 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
    str += '-';
    str += time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
    str += ' ';
    str += time.getHours();
    str += ':';
    str += time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
    return str;
}

/**
 * 距当前时间点的时长
 * @prama time 13位时间戳
 * @return str x秒 / x分钟 / x小时
 */
export function formateTime(time) {
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;
    const now = new Date().getTime();
    const diffValue = now - time;

    // 计算差异时间的量级
    const secondC = diffValue / second;
    const minC = diffValue / minute;
    const hourC = diffValue / hour;
    const dayC = diffValue / day;

    if (dayC >= 1) {
        return parseInt(dayC) + "天";
    } else if (hourC >= 1) {
        return parseInt(hourC) + "小时";
    } else if (minC >= 1) {
        return parseInt(minC) + "分钟";
    } else if (secondC >= 1) {
        return parseInt(secondC) + "秒";
    } else {
        return '0秒';
    }
}
export function getQueryString(name) {
	let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	let r = window.location.search.substr(1).match(reg);
	if (r != null) {
			return unescape(r[2]);
	}
	return null;
}

const cardNameAnalysis = [ '推荐摄入量', '饮食原则', '肠内营养补充建议', '饮食方案', '饮食禁忌', '三餐食谱', '运动建议', '心理建议' ];
const cardKeyAnalysis = [ 'recommendedIntake', 'dietPrinciples', 'enteralNutritionAdvice', 'mealPlan', 'dietaryRestrictions', 'dailyMenu', 'exerciseTips', 'mentalHealthTips' ];


export const contentAnalysis2 = (txt) => {
	return txt.replace(/---/g, '').replace(/\*\*/g, '').replace(/\#/g, '').replace(/\|/g, '')

};
// deepseek返回的智能干预方案数据解析
export const contentAnalysis = (txt) => {
	return txt.replace(/---/g, '').replace(/\*\*/g, '').replace(/<br\s*\/?>/g, "\n").split("###") // 过滤掉索引 0
		.map(content => {
			const title = cardNameAnalysis.find(name => content.includes(name)) || "其他";
			const keyIndex = cardNameAnalysis.indexOf(title);
			const key = keyIndex !== -1 ? cardKeyAnalysis[keyIndex] : undefined;

			// 过滤掉 title 关键词，保留后面的内容
			const filteredContent = key ? content.replace(title, "").trim() : content;

			return { title, key, content: filteredContent };
		});
};